// foodieId.js
// Generates and stores a persistent unique ID for the foodie

import { get, set } from 'idb-keyval';

const LOCAL_FOODIE_ID_KEY = 'fogg_foodie_id';

export async function getOrCreateFoodieId() {
  // First, try IndexedDB
  let foodieId = await get(LOCAL_FOODIE_ID_KEY);

  // Fallback to localStorage in case IndexedDB is not supported
  if (!foodieId) foodieId = localStorage.getItem(LOCAL_FOODIE_ID_KEY);

  if (!foodieId) {
    foodieId = crypto.randomUUID();
    await set(LOCAL_FOODIE_ID_KEY, foodieId);
    localStorage.setItem(LOCAL_FOODIE_ID_KEY, foodieId);
  }

  return foodieId;
}
